export type FormIdentifier = Readonly<{
    formId: string;
    equipmentId: string;
    materialId: string;
}>;

export const initialFormIdentifier: FormIdentifier = {
    formId: '',
    equipmentId: '',
    materialId: '',
};
